import store from '@state/store'
import * as moment from 'moment'
import axios from 'axios'
class ProviderChatService {
  timer = null
  innerTimer = null
  connection = null
  provider = null
  fs = null
  constructor() {
    this.baseUrl = 'wss://20ro2sazgf.execute-api.us-east-1.amazonaws.com/qa'
  }

  connect() {
    const patient = store.state.chat.patientProviderDetails
    this.baseUrl = patient.socketURL ? patient.socketURL : this.baseUrl
    const connectionUrl = `${this.baseUrl}?userId=${
      patient.patient_name
    }&reason=${patient.reason_for_visit}&providerType=${
      patient.provider_type
    }&isPatient=True&credential=${patient.credential_id}&patientId=${
      patient.patient_id
    }&orgName=${encodeURIComponent(patient.org_name)}`
    this.connection = new WebSocket(connectionUrl)

    this.connection.onopen = async (event) => {
      console.warn('Successfully connected to the echo websocket server...')
      store.dispatch('chat/setConnectionStatus', true)
      store.dispatch('chat/setProviderResponseStatus', true)
      this.heartBeatCall()
    }
    this.connection.binaryType = 'blob'
    this.connection.onmessage = (event) => {
      // console.log(event)
      const messages = JSON.parse(event.data)
      // console.log(messages);
      if (
        (messages && messages.Position) ||
        (messages && messages.contentType === 'text/plain')
      ) {
        // console.log(messages)
        this.onMessage(messages)
      }
    }
  }

  getCredential(id) {
    return axios.get(`/api/v1/users/${id}`)
  }

  inactiveTimer() {
    clearTimeout(this.timer)
    clearTimeout(this.innerTimer)
    const timerLength =
      store.state.chat.chatDialog &&
      store.state.chat.chatDialog.component === 'Wait'
        ? 10
        : 3
    const innerTimerLength = 2
    this.timer = setTimeout(() => {
      if (
        store.state.chat.chatDialog &&
        store.state.chat.chatDialog.component === 'Wait'
      ) {
        store.dispatch('chat/setProviderResponseStatus', false)
        this.connection.close()
        store.dispatch('chat/setLoadingStatus', false)
        store.dispatch('chat/setInactiveStatus', false)
      } else if (
        store.state.chat.chatDialog &&
        store.state.chat.chatDialog.component === 'Chat'
      ) {
        this.innerTimer = setTimeout(() => {
          const data1 = {
            content:
              'We’re sorry, a provider appears to be unavailable or not responding at the moment. Please try again later.',
            me: false,
            contentType: 'text/plain',
          }
          store.dispatch('chat/setChatMessage', data1)
          this.connection.close()
          store.dispatch('chat/setLoadingStatus', false)
          store.dispatch('chat/setInactiveStatus', false)
        }, innerTimerLength * 60 * 1000)

        const data = {
          content:
            'Please respond to keep the chat going. Otherwise the chat will end if there is no activity.',
          me: false,
          contentType: 'text/plain',
        }
        store.dispatch('chat/setChatMessage', data)
      }
    }, timerLength * 60 * 1000)
  }

  sendMessage(message) {
    this.inactiveTimer()
    if (message.contentType !== 'text/plain' && message.chunkSize === 'NA') {
      this.sendBase64(message)
    } else if (
      message.contentType !== 'text/plain' &&
      message.chunkSize !== 'NA'
    ) {
      this.uploader(message.content)
    } else {
      // console.log(message)
      const data = {
        ReceiverId: this.provider,
        Msg: message.content,
        contentType: message.contentType,
        action: 'sendMessage',
      }
      this.connection.send(JSON.stringify(data))
    }
  }

  uploader(file) {
    this.fs = new FileSlicer(file)
    store.dispatch('chat/setLoadingStatus', true)
    this.sendLargeFile(file)
    const localthis = this
    this.connection.onmessage = (ms) => {
      // console.log("ms",ms);
      ms = JSON.parse(ms.data)
      if (ms.received === 'ok') {
        localthis.fs.slices = localthis.fs.slices - 1
        if (localthis.fs.slices > 0) {
          localthis.sendLargeFile(file)
        }
      } else {
        localthis.onMessage(ms)
      }
    }
  }

  sendLargeFile(file) {
    // console.log(this.fs.getNextSlice());
    this.fs.getNextSlice().then((res) => {
      const data = {
        ReceiverId: this.provider,
        Msg: res,
        contentType: file.type,
        chunkId: this.fs.slices,
        fileName: file.name,
        chunkSize: this.fs.sliceSize,
        // eslint-disable-next-line no-unneeded-ternary
        isEOF: this.fs.slices > 1 ? false : true,
        action: 'sendMessage',
      }
      if (this.fs.slices === 1) {
        const data = {
          content: file.name,
          me: true,
          contentType: file.type,
        }
        store.dispatch('chat/setChatMessage', data)
        store.dispatch('chat/setLoadingStatus', false)
      }
      // console.log(data);
      this.connection.send(JSON.stringify(data))
    })
  }

  sendBase64(message) {
    const data = {
      ReceiverId: this.provider,
      Msg: message.content,
      contentType: message.contentType,
      chunkId: message.chunkId,
      fileName: message.fileName,
      chunkSize: message.chunkSize,
      isEOF: message.isEOF,
      action: 'sendMessage',
    }
    this.connection.send(JSON.stringify(data))
  }

  heartBeatCall() {
    const data = {
      ReceiverId: store.state.chat.patientProviderDetails.patient_name,
      Msg: 'getPosition',
      action: 'sendMessage',
      contentType: 'text/plain',
    }
    // console.log("heartBeatCall");
    this.connection.send(JSON.stringify(data))
  }

  onMessage(messages) {
    // console.log("in on message", messages);
    if (messages) {
      this.provider = this.provider ? this.provider : messages.SenderName
      const user = {
        ...store.state.chat.patientProviderDetails,
        provider_name: messages.SenderName,
        provider_type: messages.ProviderType,
      }
      if (messages && messages.Position) {
        store.dispatch('chat/setChatDetails', messages)
        this.inactiveTimer()
      } else if (
        messages &&
        messages.Message &&
        messages.Message.includes('How can I help you today?')
      ) {
        store.dispatch('chat/setChatDetails', user)
        store.dispatch('chat/setChatDialogStatus', {
          component: 'Chat',
          dialog: true,
        })
        // clearInterval(this.timer)
        const data = {
          content: messages.Message,
          me: false,
          contentType: messages.contentType,
        }
        store.dispatch('chat/setChatMessage', data)
      } else if (
        messages &&
        messages.Message &&
        messages.Message.includes('exited the chat session at')
      ) {
        clearTimeout(this.timer)
        clearTimeout(this.innerTimer)
        store.dispatch('chat/setInactiveStatus', false)
        const splitData = messages.Message.split('session at')
        const time = splitData[1].split(' ')
        const updatedMessage =
          splitData[0] +
          'session at ' +
          moment
            .utc(time[1] + 'T' + time[2])
            .local()
            .format('yyyy-MM-DD hh:mm')
        const data = {
          content: updatedMessage,
          me: false,
          contentType: messages.contentType,
        }
        store.dispatch('chat/setChatMessage', data)
      } else {
        const data = {
          content: messages.Message,
          me: false,
          contentType: messages.contentType,
        }
        store.dispatch('chat/setChatMessage', data)
      }
    }
  }

  onDisconnect() {
    this.connection.close()
    clearTimeout(this.timer)
    clearTimeout(this.innerTimer)
    store.dispatch('chat/setLoadingStatus', false)
    store.dispatch('chat/setConnectionStatus', false)
    // console.log("disconnected called")
  }
}

class FileSlicer {
  constructor(file) {
    this.sliceSize = 32000
    this.slices = Math.ceil(file.size / this.sliceSize)

    this.currentSlice = 0

    this.start = 0
    this.end = 0

    this.getNextSlice = function () {
      this.start = this.currentSlice * this.sliceSize
      this.end = Math.min((this.currentSlice + 1) * this.sliceSize, file.size)
      this.currentSlice = this.currentSlice + 1
      const fileChunk = file.slice(this.start, this.end, file.type)
      const base64 = this.getBase64(fileChunk)
      // console.log(base64);
      return base64
    }

    this.getBase64 = function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    }
  }
}

export const providerChatService = new ProviderChatService()
